// DE
export const hotelRoomsManager = {
  header: {
    eyebrow: "Hotelzimmer",
    title: "Zimmerverwaltung",
    subtitle:
      "Erstellen Sie Zimmertypen und generieren Sie die physischen Einheiten mit ihrer Nummerierung. Diese Zimmer werden mit Channex synchronisiert.",
    addRoom: "Zimmer hinzufügen",
  },
  states: {
    loading: "Zimmer werden geladen...",
    emptyTitle: "Noch keine Zimmer",
    emptySubtitle:
      "Erstellen Sie den ersten Zimmertyp, um Tarife und Verfügbarkeit in Channex einzurichten.",
    addFirstRoom: "Erstes Zimmer hinzufügen",
  },
  card: {
    roomsBadge: "{count} Zimmer | {count} Zimmer",
    maxGuests: "Max. {count} Gäste",
    editTitle: "Zimmer bearbeiten",
    deleteTitle: "Zimmer löschen",
    adults: "{count} Erwachsener | {count} Erwachsene",
    children: "{count} Kind | {count} Kinder",
    infants: "{count} Kleinkind | {count} Kleinkinder",
    units: "Einheiten",
  },
  physical: {
    title: "Physische Zimmer",
    subtitle:
      "Bearbeiten Sie Nummer oder Namen jedes Zimmers oder verschieben Sie es in einen anderen Typ. Die Buchungen ziehen mit um. Ziehen Sie die Zimmer am Griff, um sie innerhalb ihres Typs zu sortieren: In dieser Reihenfolge erscheinen sie im Kalender.",
    roomsCount: "{count} Zimmer | {count} Zimmer",
    savingOrder: "Reihenfolge wird gespeichert…",
    selectAll: "Alle auswählen",
    clearSelection: "Auswahl aufheben",
    dragToOrder: "Zum Sortieren ziehen",
    selectRoom: "{label} auswählen",
    roomFallback: "Zimmer",
    codePlaceholder: "Nr. / Code",
    namePlaceholder: "Name",
  },
  bar: {
    selectedCount: "Zimmer ausgewählt | Zimmer ausgewählt",
    clearSelection: "Auswahl aufheben",
    changeType: "Typ ändern",
  },
  modal: {
    createTitle: "Neues Zimmer",
    editTitle: "Zimmer bearbeiten",
    createSubtitle: "Typ definieren und physische Einheiten generieren",
    editSubtitle: "Details des Zimmertyps aktualisieren",
    basicInfo: "Grundinformationen",
    nameLabel: "Zimmername",
    namePlaceholder: "Z. B. Doppelzimmer, Junior-Suite…",
    descriptionLabel: "Beschreibung",
    optional: "(optional)",
    descriptionPlaceholder: "Meerblick, Terrasse, Minibar…",
    inventorySection: "Bestand und Kapazität",
    countLabel: "Anzahl der Zimmer",
    countHintZero:
      "Ohne Zimmer erstellt: Sie können ihm anschließend vorhandene Zimmer aus der Liste der physischen Zimmer zuweisen.",
    countHint: "Gesamtzahl der physischen Einheiten dieses Typs",
    capacityLabel: "Gesamtkapazität (Gäste)",
    capacityHint: "Maximum für Erwachsene + Kinder + Kleinkinder zusammen",
    priceLabel: "Preis pro Nacht",
    priceHint:
      "Damit wird der Standardtarif erstellt. Sie können ihn später unter „Hoteltarife“ anpassen.",
    adultsLabel: "Erwachsene",
    childrenLabel: "Kinder",
    infantsLabel: "Kleinkinder",
    numberingSection: "Zimmernummerierung",
    toggleOn: "An",
    toggleOff: "Aus",
    numberingHintCreate:
      "Zimmer werden mit einem automatischen Code erstellt. Sie können ihn einzeln in der Liste der physischen Zimmer ändern oder die Nummerierung unter „Bearbeiten“ festlegen, damit die nächsten Zimmer sie direkt erhalten.",
    prefixLabel: "Code-Präfix",
    prefixPlaceholder: "Z. B. 10  oder  A-",
    prefixHint: 'Z. B. Präfix "10" + Start 1 → 101, 102…',
    startNumberLabel: "Startnummer",
    paddingLabel: "Auffüllung",
    paddingHint: "3 → 001, 002…",
    nameModeLabel: "Namen der physischen Zimmer",
    nameModeType: "Nur Typ",
    nameModeTypeExample: "Doppelzimmer",
    nameModeTypeCode: "Typ + Code",
    nameModeTypeCodeExample: "Doppelzimmer 101",
    preview: {
      lead: "Wir erstellen",
      roomsNoun: "Zimmer | Zimmer",
      withNumbering: "mit dieser Nummerierung. Beispiel:",
    },
    numberingHintKeep:
      "Bestehende Zimmer behalten ihre Nummer. Diese Nummerierung gilt für die Zimmer, die Sie ab jetzt hinzufügen.",
    numberingHintZero:
      "Ohne Zimmer gibt es nichts zu nummerieren. Weisen Sie ihm vorhandene Zimmer aus der Liste der physischen Zimmer zu.",
    numberingHintDisabled:
      "Physische Zimmer werden nicht automatisch generiert. Sie können das jederzeit aktivieren.",
    cancel: "Abbrechen",
    saving: "Wird gespeichert…",
    creating: "Wird erstellt…",
    saveChanges: "Änderungen speichern",
    createRoom: "Zimmer erstellen",
  },
  delete: {
    title: "Zimmer löschen",
    subtitle: "Diese Aktion kann nicht rückgängig gemacht werden",
    confirmCopy: "Geben Sie zur Bestätigung den Zimmernamen ein:",
    placeholder: "Zimmername",
    cancel: "Abbrechen",
    deleting: "Wird gelöscht...",
    confirm: "Löschen",
  },
  change: {
    title: "Typ {target} ändern",
    subtitle: "Die Zimmernummer ändert sich nicht",
    newTypeLabel: "Neuer Typ",
    newTypePlaceholder: "Wählen Sie, in welchen Typ es wechselt…",
    blocksHead: "Eine Buchung blockiert die Änderung | {count} Buchungen blockieren die Änderung",
    moves: "Wechselt in den neuen Typ",
    stays: "Bleibt im aktuellen Typ",
    addMissing: "{labels} zur Änderung hinzufügen und erneut versuchen",
    stockLabel: "Zimmer im Verkauf",
    checkingReservations: "Es wird geprüft, welche Buchungen in {target} liegen…",
    thisRoom: "diesem Zimmer",
    theseRooms: "diesen Zimmern",
    theRoom: "dem Zimmer",
    theRooms: "den Zimmern",
    noReservations: "Es gibt keine Buchungen in {target}.",
    reservationsLeave: "Buchung zieht um | Buchungen ziehen um",
    with: "zusammen mit {target}",
    moreReservations: "und {count} weitere Buchung | und {count} weitere Buchungen",
    greyLegend: "Die grau markierten Zimmer bleiben in ihrem aktuellen Typ.",
    retry: "Erneut versuchen",
    cancel: "Abbrechen",
    applying: "Wird geändert…",
    confirm: "Ja, Typ ändern",
    titleTargetOne: "von Zimmer {label}",
    titleTargetMany: "von {count} Zimmer | von {count} Zimmern",
    textZero: "Diese Zimmer haben bereits diesen Typ: Wählen Sie einen anderen, um sie zu verschieben.",
    textOne:
      "Das Zimmer behält seine Nummer und seine Buchungen: Nur der Typ, unter dem es verkauft wird, ändert sich. Wo es jetzt ist, steht ein Zimmer weniger im Verkauf, im neuen Typ eines mehr.",
    textMany:
      "Die {count} Zimmer behalten ihre Nummer und ihre Buchungen: Nur der Typ, unter dem sie verkauft werden, ändert sich. Wo sie jetzt sind, stehen {count} Zimmer weniger im Verkauf, im neuen Typ {count} mehr.",
  },
  blockTitles: {
    huespedDentro: "Ein Gast ist eingecheckt",
    reservaRepartida: "Die Buchung belegt weitere Zimmer",
    reservaSinAsignar: "Der Buchung fehlen einige ihrer Zimmer",
    fallback: "Kann nicht verschoben werden",
  },
  groups: {
    noType: "Kein Typ zugewiesen",
  },
  reservation: {
    noName: "Kein Name",
  },
  toasts: {
    roomsChanged: "Zimmertyp geändert | {count} Zimmer haben den Typ gewechselt",
    changedSyncing: "{done} · Kanäle werden aktualisiert",
    created: "Zimmer erfolgreich erstellt",
    updated: "Zimmer aktualisiert",
    deleted: "Zimmer gelöscht",
  },
  errors: {
    generic: "Es ist ein Fehler aufgetreten.",
    loadRooms: "Fehler beim Laden der Zimmer",
    updateQty: "Die Anzahl konnte nicht aktualisiert werden",
    savePhysicalRoom: "Das Zimmer konnte nicht gespeichert werden",
    saveOrder: "Die Zimmerreihenfolge konnte nicht gespeichert werden.",
    checkReservations: "Es konnte nicht geprüft werden, welche Buchungen in diesen Zimmern liegen.",
    changeType: "Der Zimmertyp konnte nicht geändert werden.",
    noProperty: "Die Unterkunft konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
    saveRoom: "Fehler beim Speichern des Zimmers",
    deleteRoom: "Fehler beim Löschen",
  },
};
